export enum RoomPresentationActions {
  JOIN_ROOM = 'Room/JOIN_ROOM',
  CLOSE_ROOM = 'Room/CLOSE_ROOM',
}
